'use strict';//Indicating browser should run only in java script mode
//http://stackoverflow.com/questions/20369377/how-to-use-http-get-in-angularjs-correctly-in-specific-for-an-external-api-cal

//*******PURPOSE: The purpose of the service is to handle each and every http wcf calls related to login functionality
//*******EFFECTIVE FILES: Views/Rx/PreferredSureScriptPharmacies.html
//*******CREATED BY: Malini K
//*******CREATED DATE: 06/18/2014
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

angular.module('EMR.PreferredSureScriptPharmacies').service('PreferredSureScriptPharmaciesCommonService', ['CommonPostService', function (CommonPostService) {
	//###################   GET NOT REVIEWED PRSCRIPTION COUNT BLOCK START#########################
	//*******PURPOSE:THIS IS USED FOR GETTING NOT REVIEWED PRSCRIPTION COUNT   
	//*******CREATED BY:CH.SAIRAM
	//*******CREATED DATE:16TH JAN,2017
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX

	this.rxServiceGetNotReviewedPrescriptionsCount = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST; // CURSO
		return CommonPostService.httpPostData('POST', CommonPostService.EHR_Rx_Common_API() + "GetNotReviewedPrescriptionsCount", postData).then(
			function (result) {
				return result;
			});
	};
	//###################    GET NOT REVIEWED PRSCRIPTION LIST BLOCK END#########################
}])